import { Controller } from "@hotwired/stimulus"
import { formatBRL } from "../utils/format"

// The cancellation screen's steppers: keeps each line within what it still has
// left to cancel, totals the picked units at their own unit price, and holds the
// confirm button shut until something is picked. Mirrors kiosk-pos, minus the
// card and balance rules — there is no balance to run out of when crediting.
export default class extends Controller {
  static targets = ["quantityInput", "total", "confirmBtn"]

  connect() {
    // A rejected submit comes back with the operator's picks already filled in,
    // so the total is recomputed rather than assumed to start at zero.
    this.#recalculate()
  }

  increment(event) {
    const input   = this.#inputFor(event)
    const maxQty  = parseInt(input.dataset.maxQty || "0", 10)
    const current = parseInt(input.value || "0", 10)

    if (current < maxQty) input.value = current + 1
    this.#recalculate()
  }

  decrement(event) {
    const input   = this.#inputFor(event)
    const current = parseInt(input.value || "0", 10)

    if (current > 0) input.value = current - 1
    this.#recalculate()
  }

  // private

  #inputFor(event) {
    return event.currentTarget.parentElement.querySelector("[data-sale-cancellation-form-target='quantityInput']")
  }

  #recalculate() {
    let units = 0
    let total = 0

    this.quantityInputTargets.forEach((input) => {
      const quantity = parseInt(input.value || "0", 10)
      units += quantity
      total += quantity * parseFloat(input.dataset.unitPrice || "0")
    })

    this.totalTarget.textContent = formatBRL(total)
    // Gated on units, not money: a line a promotion priced at R$ 0,00 still has
    // stock to give back, and totalling zero must not lock the operator out of it.
    this.confirmBtnTarget.disabled = units === 0
  }
}
